import * as yup from "yup";
import { YEARS_PAST_PET } from "../../config/params";
import { subtractYearsToDate } from "../../utils";

export const PetUpdateSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required("Pet name is required"),
  species: yup
    .string()
    .required("Species is required"),
  birthdate: yup
    .date()
    .nullable(true)
    .min(subtractYearsToDate(new Date(), YEARS_PAST_PET))
    .max(new Date()),
  breed: yup.string(),
  gender: yup.string(),
  idColor: yup.string(),
  isDesexed: yup.mixed(),
});

export const PetBirthdayUpdateSchema = yup.object({
  birthdate: yup
    .date()
    .nullable(true)
    .min(subtractYearsToDate(new Date(), YEARS_PAST_PET))
    .max(new Date()),
});

export const PetMedicalUpdateSchema = yup.object({
  medicalRecord: yup.object({
    city: yup.string().required(),
    clinicName: yup.string().required(),
  }),
});

export type PetUpdateFormType = yup.InferType<typeof PetUpdateSchema>;
export type PetBirthdayUpdateType = yup.InferType<typeof PetBirthdayUpdateSchema>;
export type PetMedicalFormType = yup.InferType<typeof PetMedicalUpdateSchema>;
